import { render, staticRenderFns } from "./KeepRetailPackagingDisplay.vue?vue&type=template&id=3e63a63d&scoped=true&"
import script from "./KeepRetailPackagingDisplay.vue?vue&type=script&lang=js&"
export * from "./KeepRetailPackagingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e63a63d",
  null
  
)

export default component.exports